<template>
  <header id="masthead" class="navbar">
    <div class="container d-flex align-items-center">
      <logo :height="34" :light="true"></logo>
      <main-nav></main-nav>
      <nav-right :toggle="'MainNavToggle'"></nav-right>
    </div>
  </header>
</template>

<script>
import Logo from '@/components/header/Logo.vue'
import MainNav from '@/components/header/MainNav.vue'
import NavRight from '@/components/header/NavRight.vue'

export default {
  name: 'app-header',
  components: {
    logo: Logo,
    'main-nav': MainNav,
    'nav-right': NavRight
  }
}
</script>
